import i18next, { use, changeLanguage } from 'i18next';

import LocizeBackend, {
  type LocizeBackendOptions
} from 'i18next-locize-backend';

import LanguageDetector from 'i18next-browser-languagedetector';

import { setDateLocale } from '@iamip/utils/dateHelpers';

import {
  FAILED_TO_CHANGE_LANGUAGE,
  TRANSLATION_INIT_ERROR
} from '@/constants/errors';

import {
  allowedLanguages,
  DEFAULT_NAMESPACE,
  ENGLISH_LANGUAGE
} from '@iamip/constants/translations';

use(LocizeBackend)
  .use(LanguageDetector)
  .init<LocizeBackendOptions>({
    debug: import.meta.env.DEV,
    returnNull: false,
    returnEmptyString: false,
    fallbackLng: ENGLISH_LANGUAGE,
    ns: DEFAULT_NAMESPACE,
    saveMissing: false,
    defaultNS: DEFAULT_NAMESPACE,
    supportedLngs: allowedLanguages,
    backend: {
      referenceLng: ENGLISH_LANGUAGE,
      version: import.meta.env.VITE_APP_LOCIZE_PROJECT_VERSION,
      projectId: import.meta.env.VITE_APP_LOCIZE_PROJECT_ID,
      apiKey: import.meta.env.VITE_APP_LOCIZE_API_KEY,
      cdnType: 'pro'
    }
  })
  .then(() => {
    if (
      window.currentUser &&
      window.currentUser.language !== i18next.language
    ) {
      setDateLocale(window.currentUser.language);
      changeLanguage(window.currentUser.language).catch(e => {
        console.error(FAILED_TO_CHANGE_LANGUAGE, e);
      });
    }
  })
  .catch(e => console.error(TRANSLATION_INIT_ERROR, e));

export const { t } = i18next;

export default i18next;
